import {
  WEBSOCKET_FETCH_CHANNELS_LOADING, WEBSOCKET_FETCH_CHANNELS_DONE, WEBSOCKET_FETCH_MESSAGES_LOADING, WEBSOCKET_FETCH_MESSAGES_DONE, WEBSOCKET_FETCH_MESSAGES_ERROR, WEBSOCKET_SEND_MESSAGE_LOADING, WEBSOCKET_SEND_MESSAGE_DONE, WEBSOCKET_SEND_MESSAGE_ERROR, WEBSOCKET_FETCH_CHANNELS_SUBSCRIBERS_LOADING, WEBSOCKET_FETCH_CHANNELS_SUBSCRIBERS_DONE, WEBSOCKET_FETCH_CHANNELS_SUBSCRIBERS_ERROR, WEBSOCKET_POST_CHANNELS_SUBSCRIBERS_LOADING, WEBSOCKET_POST_CHANNELS_SUBSCRIBERS_DONE, WEBSOCKET_POST_CHANNELS_SUBSCRIBERS_ERROR, 
  WEBSOCKET_FETCH_MESSAGES_EMAIL_LOADING, WEBSOCKET_FETCH_MESSAGES_EMAIL_DONE, WEBSOCKET_FETCH_MESSAGES_EMAIL_ERROR,
} from './actions'

export default {
  [WEBSOCKET_FETCH_CHANNELS_LOADING] (state) {
    state.isLoadingChannels = true
  },

  [WEBSOCKET_FETCH_CHANNELS_DONE] (state) {
    state.isLoadingChannels = false
  },

  [WEBSOCKET_FETCH_MESSAGES_LOADING] (state) {
    state.messages = []
    state.isLoadingMessages = true
  },

  [WEBSOCKET_FETCH_MESSAGES_DONE] (state, messages) {
    state.messages = messages
    state.isLoadingMessages = false
  },

  [WEBSOCKET_FETCH_MESSAGES_ERROR] (state, errorMessages) {
    state.messages = []
    state.errorMessages = errorMessages
    state.isLoadingMessages = false
  },

  [WEBSOCKET_SEND_MESSAGE_LOADING] (state) {
    state.message = ''
    state.isLoadingSendMessages = true
  },

  [WEBSOCKET_SEND_MESSAGE_DONE] (state, message) {
    state.message = message
    state.isLoadingSendMessages = false
  },

  [WEBSOCKET_SEND_MESSAGE_ERROR] (state, errorMessage) {
    state.message = []
    state.errorMessage = errorMessage
    state.isLoadingSendMessages = false
  },

  [WEBSOCKET_FETCH_CHANNELS_SUBSCRIBERS_LOADING] (state) {
    state.isLoadingFetchSubscribers = true
  },

  [WEBSOCKET_FETCH_CHANNELS_SUBSCRIBERS_DONE] (state, subscribers) {
    state.subscribers = subscribers
    state.isLoadingFetchSubscribers = false
  },

  [WEBSOCKET_FETCH_CHANNELS_SUBSCRIBERS_ERROR] (state, errorFetchSubscribers) {
    state.subscribers = []
    state.errorFetchSubscribers = errorFetchSubscribers
    state.isLoadingFetchSubscribers = false
  },

  [WEBSOCKET_POST_CHANNELS_SUBSCRIBERS_LOADING] (state) {
    state.isLoadingPostSubscribers = true
  },

  [WEBSOCKET_POST_CHANNELS_SUBSCRIBERS_DONE] (state) {
    state.isLoadingPostSubscribers = false
  },

  [WEBSOCKET_POST_CHANNELS_SUBSCRIBERS_ERROR] (state, errorPostSubscribers) {
    state.errorPostSubscribers = errorPostSubscribers
    state.isLoadingPostSubscribers = false
  },

  [WEBSOCKET_FETCH_MESSAGES_EMAIL_LOADING](state) {
    state.messageEmail = []
    state.isLoadingMessageEmail = true
  },

  [WEBSOCKET_FETCH_MESSAGES_EMAIL_DONE](state, messages) {
    state.messageEmail = messages
    state.isLoadingMessageEmail = false
  },

  [WEBSOCKET_FETCH_MESSAGES_EMAIL_ERROR](state, errorMessages) {
    state.messageEmail = []
    state.errorMessageEmail = errorMessages
    state.isLoadingMessageEmail = false
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/chat/mutations.js